<div class="flex flex-col h-full">
  <!-- Banner explaining the seed-managed nature of these rules -->
  <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-3">
    <fa-icon [icon]="'info-circle'" class="h-5 w-5 text-blue-600 mt-0.5"></fa-icon>
    <div class="text-sm text-blue-900">
      <p class="font-semibold mb-1">Auto-generated rules ({{ totalRulesCount() }} total)</p>
      <p>
        These dependency rules are produced from the canonical Country -> State -> County dataset
        (<code class="text-xs">_locations.py</code>) by the
        <code class="text-xs">seed_validation_rules</code> management command. You can tune the
        severity or temporarily disable a rule here, but the country / state / county lists
        themselves are managed by editing the dataset and re-running the seed.
      </p>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto bg-base-100 border border-base-300 rounded-lg">
    <div
      *ngIf="countryGroups().length === 0"
      class="py-12 text-center text-sm text-base-content/70"
    >
      No CROSS_FIELD_VALUE_DEPENDENCY rules loaded.
    </div>

    <ul>
      <li *ngFor="let c of countryGroups(); trackBy: trackCountry" class="border-b border-base-300 last:border-b-0">
        <button
          type="button"
          (click)="toggleExpand(c.countryCode)"
          class="w-full flex items-center justify-between px-4 py-3 hover:bg-base-200 transition-colors text-left"
        >
          <div class="flex items-center gap-3">
            <fa-icon
              [icon]="c.expanded ? 'chevron-down' : 'chevron-right'"
              class="h-4 w-4 text-base-content/70"
            ></fa-icon>
            <span class="text-base font-semibold text-primary">{{ c.countryCode }}</span>
            <span class="text-xs text-base-content/70">
              {{ c.states.length }} {{ c.states.length === 1 ? 'state' : 'states' }} with county
              rules
            </span>
          </div>
          <div class="flex items-center gap-3">
            <span
              class="badge badge-sm"
              [class.badge-error]="c.countryRule.severity === 'ERROR'"
              [class.badge-warning]="c.countryRule.severity === 'WARNING'"
            >
              {{ c.countryRule.severity }}
            </span>
            <input
              type="checkbox"
              class="toggle toggle-sm"
              [checked]="c.countryRule.is_active"
              (click)="$event.stopPropagation()"
              (change)="toggleActive(c.countryRule)"
              [attr.aria-label]="'Toggle active for country rule ' + c.countryCode"
            />
            <button
              type="button"
              class="text-primary-focus hover:text-primary transition-colors"
              (click)="$event.stopPropagation(); openEdit(c.countryRule)"
              aria-label="Edit country rule"
            >
              <fa-icon [icon]="'edit'" class="h-4 w-4"></fa-icon>
            </button>
          </div>
        </button>

        <!-- State sub-rows -->
        <ul *ngIf="c.expanded" class="bg-base-200">
          <li
            *ngFor="let s of c.states; trackBy: trackState"
            class="flex items-center justify-between px-4 py-2 pl-12 border-t border-base-300 hover:bg-base-100 transition-colors"
          >
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-primary">{{ s.stateName }}</div>
              <div class="text-xs text-base-content/70 truncate">
                {{ countyCount(s.stateRule) }} counties: {{ allowedPreview(s.stateRule) }}
              </div>
            </div>
            <div class="flex items-center gap-3 ml-3">
              <span
                class="badge badge-sm"
                [class.badge-error]="s.stateRule.severity === 'ERROR'"
                [class.badge-warning]="s.stateRule.severity === 'WARNING'"
              >
                {{ s.stateRule.severity }}
              </span>
              <input
                type="checkbox"
                class="toggle toggle-sm"
                [checked]="s.stateRule.is_active"
                (change)="toggleActive(s.stateRule)"
                [attr.aria-label]="'Toggle active for state rule ' + s.stateName"
              />
              <button
                type="button"
                class="text-primary-focus hover:text-primary transition-colors"
                (click)="openEdit(s.stateRule)"
                aria-label="Edit state rule"
              >
                <fa-icon [icon]="'edit'" class="h-4 w-4"></fa-icon>
              </button>
            </div>
          </li>
          <li *ngIf="c.states.length === 0" class="px-4 py-3 pl-12 text-xs text-base-content/70 italic">
            No state-to-county rules for this country.
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<app-location-rule-editor-modal
  [modalId]="editorModalId"
  [rule]="editingRule()"
  (closed)="onEditorClosed()"
></app-location-rule-editor-modal>
